import api from "../../utilities/api";

export function fetchIpList(options = {}) {
    const { page = 0, limit = 10, search = "", country = "All", flaggedOnly = false, fromDate = null, toDate = null } = options;
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (country && country !== "All") params.append("country", country);
    if (flaggedOnly) params.append("flaggedOnly", "true");

    // Handle dayjs objects - convert to ISO string
    if (fromDate) {
        const dateStr = fromDate.$d ? fromDate.toISOString() : (fromDate.toISOString ? fromDate.toISOString() : fromDate);
        params.append("fromDate", dateStr);
    }
    if (toDate) {
        const dateStr = toDate.$d ? toDate.toISOString() : (toDate.toISOString ? toDate.toISOString() : toDate);
        params.append("toDate", dateStr);
    }

    return api.get(`/api/iplookup?${params.toString()}`).then((res) => res.data.data);
}

export function fetchIpStats() {
    return api.get("/api/iplookup/stats").then((res) => res.data.data);
}

export function fetchIpDetails(ip) {
    return api.get(`/api/iplookup/${ip}`).then((res) => res.data.data);
}
